// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
import DialogController from "./dialog_controller"
import DirectUploadController from "./direct_upload_controller"
import DropdownController from "./dropdown_controller"
import PieceTagsController from "./piece_tags_controller"
import PlacesAutocompleteController from "./places_autocomplete_controller"
import ToastController from "./toast_controller"
import ToggleController from "./toggle_controller"
import VideoController from "./video_controller"

application.register("autocomplete", AutocompleteController)
application.register("dialog", DialogController)
application.register("direct-upload", DirectUploadController)
application.register("dropdown", DropdownController)
application.register("piece-tags", PieceTagsController)
application.register("places-autocomplete", PlacesAutocompleteController)
application.register("toast", ToastController)
application.register("toggle", ToggleController)
application.register("video", VideoController)
